import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMovementAdvancesQuickInfo extends Layout {
	sourceAdvancesForMovement: DataSource;
	table1: Table;
}
